module.exports = __webpack_public_path__ + "static/media/margarita.d3560066.png";